import { NewActivityViewLog } from 'models/ActivityViewLogModel';

import { ApiRouteService } from '../services';
import { HttpRequestOptionsType } from '../types';
import { HttpClient } from './HttpClient';

export class ActivityViewLogClient {
  private readonly httpClient: HttpClient;
  private readonly baseUrl = `${ApiRouteService.getCompumedApiBaseRoute()}/api/activityviewlogs`;

  constructor(httpClient: HttpClient) {
    this.httpClient = httpClient;
  }

  public async logActivityView(logData: NewActivityViewLog, options?: HttpRequestOptionsType): Promise<void> {
    const requestOptions = await this.httpClient.createStandardOptions('POST', logData, options);
    const request = fetch(this.baseUrl, requestOptions);
    await this.httpClient.fetch(request); // Assuming POST returns 201 Created or 204 No Content
  }

  // Potential future method if models are not enriched by backend:
  // public async getUnreadStatusForItems(items: { entityType: string; entityId: number }[], options?: HttpRequestOptionsType): Promise<any[]> {
  //   // This would likely be a POST request with the list of items to check
  //   // The backend would return which of these are unread for the current user
  //   const requestOptions = await this.httpClient.createStandardOptions('POST', items, options, `${this.baseUrl}/unreadstatus`);
  //   const request = fetch(requestOptions.url, requestOptions.options);
  //   return this.httpClient.fetchAndParse<any[]>(request);
  // }
}
